const LOCAL_STORAGE_PREFIX: string = 'onboarding-';

export { LOCAL_STORAGE_PREFIX };
